import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-stack" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "mb-2" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }

import AppTextField from "@/shared/components/ui/AppTextField.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactPersonForm',
  props: {
    first_name: { default: "" },
    last_name: { default: "" },
    email: { default: "" },
    phone: { default: "" },
    phone_alt: { default: "" },
    errors: { default: () => ({}) }
  },
  emits: [
  "update:first_name",
  "update:last_name",
  "update:email",
  "update:phone",
  "update:phone_alt",
],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _directive_mask = _resolveDirective("mask")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(AppTextField, {
          "model-value": __props.first_name,
          label: "First Name",
          "label-icon": "mdi-account-outline",
          placeholder: "John",
          "error-messages": __props.errors.first_name ? [__props.errors.first_name] : [],
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:first_name', $event)))
        }, null, 8, ["model-value", "error-messages"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(AppTextField, {
          "model-value": __props.last_name,
          label: "Last Name",
          "label-icon": "mdi-account-outline",
          placeholder: "Doe",
          "error-messages": __props.errors.last_name ? [__props.errors.last_name] : [],
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:last_name', $event)))
        }, null, 8, ["model-value", "error-messages"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppTextField, {
          "model-value": __props.email,
          label: "Email",
          "label-icon": "mdi-email-outline",
          type: "email",
          placeholder: "name@example.com",
          "error-messages": __props.errors.email ? [__props.errors.email] : [],
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:email', $event)))
        }, null, 8, ["model-value", "error-messages"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(AppTextField, {
          "model-value": __props.phone,
          label: "Phone",
          "label-icon": "mdi-phone-outline",
          type: "tel",
          placeholder: "(555) 123 4567",
          "error-messages": __props.errors.phone ? [__props.errors.phone] : [],
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:phone', $event)))
        }, null, 8, ["model-value", "error-messages"]), [
          [_directive_mask, '(###) ### ####']
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createVNode(AppTextField, {
          "model-value": __props.phone_alt,
          label: "Alt. Phone",
          "label-icon": "mdi-phone-outline",
          type: "tel",
          placeholder: "(555) 987 6543",
          "hide-details": "",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:phone_alt', $event)))
        }, null, 8, ["model-value"]), [
          [_directive_mask, '(###) ### ####']
        ])
      ])
    ])
  ]))
}
}

})